/**
 * Adds a screen-reader only div to the bottom of the body with
 * aria-live="polite". Div is removed after a few seconds so user is unlikely to
 * tab to it.
 *
 * If a persistId is passed, announce will try to re-use a previously created div.
 * This is useful for instances where a button press is changing an announced value,
 * and fast, repeated presses would normally cause each value change to be read one
 * after the other until all the changes are announced. Instead, if the user changes
 * the value in the middle of an announcement (and the container is successfully
 * persisted) the screen reader will stop and restart the announcement with the
 * new value.
 *
 * @param {string} message - The string to be read by the screen reader
 */
export default function announce(message, liveSetting = 'polite', persistId) {
    if (typeof message !== 'string') {
        return;
    }
    // amount of time message should stay in the DOM.
    // Two seconds plus extra based on the length of the message
    const timeoutTime = persistId
        ? 3000 + message.length * 300
        : 2000 + message.length * 150;

    let el;

    if (persistId) {
        el = document.getElementById(persistId);

        if (window.sarsaAnnounceTimeout) {
            clearTimeout(window.sarsaAnnounceTimeout);
        }
    }

    if (!el) {
        el = document.createElement('div');
        el.setAttribute('aria-live', liveSetting);

        if (persistId) {
            el.setAttribute('id', persistId);
        }

        el.style.cssText = `
            position: absolute !important;
            clip: rect(1px, 1px, 1px, 1px);
            clipPath: inset(50%);
            padding: 0;
            border: 0;
            height: 1px;
            width: 1px;
            overflow: hidden;
            whiteSpace: nowrap;
        `;

        document.body.appendChild(el);
    }

    el.innerHTML = message;

    window.sarsaAnnounceTimeout = setTimeout(() => {
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    }, timeoutTime);
}
